export default __webpack_public_path__ + "static/media/client_id_password.c4ccbc95.svg";